export default __webpack_public_path__ + "static/media/ecommerce.50ee0dd3.jpg";